import styling from '../dashboards/styles/NewDecisionTree';
import { Button } from "@mui/material";

export default function CategorySelection({ t, clicked, handleClick, category, handleCategorySelect }) {
  return (
    <div style={styling.filterSection}>
      {
        categories.map((cat) => {
          return (
            <CategoryButton 
              key={cat}
              t={t}
              clicked={clicked === cat}
              disabled={category && category !== cat} 
              handleClick={() => { 
                if (clicked !== cat) {
                  handleClick(cat); 
                  handleCategorySelect(cat); 
                }
              }} 
              option={cat} />
          );
        })
      }
    </div>
  );
}

// ============================ COMPONENTS ============================

function CategoryButton({ t, clicked, handleClick, option }) {
  return (
    <Button 
    style={{
      color: clicked ? '#ab5061' : '#263828'
    }}
    onClick={handleClick}
    > 
    {t(`dashboard.decision-tree.categories.${option}`)}
    </Button>
  );
};

const categories = [
  "substitution_de_matiere_grasse",
  "selection_des_antimicrobiens",
  "substitution_des_sucres",
  "selection_des_antioxydants",
  "selection_des_emulsifiants",
  "selection_des_moussants",
  "selection_des_epaississants",
];